module.exports = __webpack_public_path__ + "static/img/pc_logo.3e9cef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/pc_logo.png
// module id = 9QFE
// module chunks = 1 3